import { useRef } from 'react';

import * as THREE from 'three';

import { useStore } from '../../../pages/workspace/hooks.ts';
import { HEMISPHERE_GROUND_COLOR, KEY_LIGHT_POSITION, KEY_LIGHT_SHADOW_CAMERA } from './lightingConstants.ts';

export function Lighting() {
  const { activeViewModes } = useStore();
  const directionalLightRef = useRef<THREE.DirectionalLight>(null);

  if (activeViewModes.render) {
    return <ambientLight intensity={5} />;
  }

  // Basic lighting for all non-render modes.
  return (
    <>
      <ambientLight intensity={1} />

      <directionalLight
        ref={directionalLightRef}
        position={KEY_LIGHT_POSITION}
        intensity={1}
        castShadow
        shadow-camera-near={KEY_LIGHT_SHADOW_CAMERA.near}
        shadow-camera-far={KEY_LIGHT_SHADOW_CAMERA.far}
        shadow-camera-left={KEY_LIGHT_SHADOW_CAMERA.left}
        shadow-camera-right={KEY_LIGHT_SHADOW_CAMERA.right}
        shadow-camera-top={KEY_LIGHT_SHADOW_CAMERA.top}
        shadow-camera-bottom={KEY_LIGHT_SHADOW_CAMERA.bottom}
      />

      <hemisphereLight groundColor={HEMISPHERE_GROUND_COLOR} intensity={1} />
    </>
  );
}
